export const CLIENT_LIST_REQUEST = 'CLIENT_LIST_REQUEST';
export const CLIENT_LIST_SUCCESS = 'CLIENT_LIST_SUCCESS';
export const CLIENT_LIST_FAILURE = 'CLIENT_LIST_FAILURE';
export const SALONSBYUSER_REQUEST = 'SALONSBYUSER_REQUEST';
export const SALONSBYUSER_SUCCESS = 'SALONSBYUSER_SUCCESS';
export const SALONSBYUSER_FAILURE = 'SALONSBYUSER_FAILURE';
export const PERMISSION_ACCESS_REQUEST = 'PERMISSION_ACCESS_REQUEST';
export const PERMISSION_ACCESS_SUCCESS = 'PERMISSION_ACCESS_SUCCESS';
export const PERMISSION_ACCESS_FAILURE = 'PERMISSION_ACCESS_FAILURE';
export const SET_CURRENT_SALON = 'SET_CURRENT_SALON';
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';
export const SALON_STATE_REQUEST = 'SALON_STATE_REQUEST';
export const SALON_STATE_SUCCESS = 'SALON_STATE_SUCCESS';
export const SALON_STATE_ERROR = 'SALON_STATE_ERROR';
export const SET_REDIRECT_URI = 'SET_REDIRECT_URI';
export const REMOVE_FB_INTEGRATION_REQUEST = 'REMOVE_FB_INTEGRATION_REQUEST';
export const REMOVE_FB_INTEGRATION_SUCCESS = 'REMOVE_FB_INTEGRATION_SUCCESS';
export const REMOVE_FB_INTEGRATION_FAILURE = 'REMOVE_FB_INTEGRATION_FAILURE';

export const CREATE_PIN_REQUEST = 'CREATE_PIN_REQUEST';
export const CREATE_PIN_SUCCESS = 'CREATE_PIN_SUCCESS';
export const CREATE_PIN_FAILURE = 'CREATE_PIN_FAILURE';

export const GET_PIN_REQUEST = 'GET_PIN_REQUEST';
export const GET_PIN_SUCCESS = 'GET_PIN_SUCCESS';
export const GET_PIN_FAILURE = 'GET_PIN_FAILURE';

export const RESET_PIN_REQUEST = 'RESET_PIN_REQUEST';
export const RESET_PIN_SUCCESS = 'RESET_PIN_SUCCESS';
export const RESET_PIN_FAILURE = 'RESET_PIN_FAILURE';

export const EMAIL_PIN_REQUEST = 'EMAIL_PIN_REQUEST';
export const EMAIL_PIN_SUCCESS = 'EMAIL_PIN_SUCCESS';
export const EMAIL_PIN_FAILURE = 'EMAIL_PIN_FAILURE';

export const ENABLE_REMOTE_LOGIN_REQUEST = 'ENABLE_REMOTE_LOGIN_REQUEST';
export const ENABLE_REMOTE_LOGIN_SUCCESS = 'ENABLE_REMOTE_LOGIN_SUCCESS';
export const ENABLE_REMOTE_LOGIN_FAILURE = 'ENABLE_REMOTE_LOGIN_FAILURE';

export const GET_EMAIL_WITH_LOGIN_REQUEST = 'GET_EMAIL_WITH_LOGIN_REQUEST';
export const GET_EMAIL_WITH_LOGIN_SUCCESS = 'GET_EMAIL_WITH_LOGIN_SUCCESS';
export const GET_EMAIL_WITH_LOGIN_FAILURE = 'GET_EMAIL_WITH_LOGIN_FAILURE';

export const REMOVE_ACCESS_REQUEST = 'REMOVE_ACCESS_REQUEST';
export const REMOVE_ACCESS_SUCCESS = 'REMOVE_ACCESS_SUCCESS';
export const REMOVE_ACCESS_FAILURE = 'REMOVE_ACCESS_FAILURE';

export const RESET_REMOVED_ACCESS = 'RESET_REMOVED_ACCESS';
